import React, { useState, useEffect, useRef } from "react";

import { toast } from "react-toastify";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { ModalTitle, FormField } from "../QueueIntegrationModal/panelKit";

const MENU_PROPS = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  getContentAnchorEl: null,
};

const FlowBuilderAttendantModal = ({ open, onSave, data, onUpdate, close }) => {
  const isMounted = useRef(true);

  const initialState = {
    queue: "",
    user: "",
  };

  const [activeModal, setActiveModal] = useState(false);

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  useEffect(() => {
    if (open === "edit") {
      (async () => {
        try {
          const user = data.data.user;

          const { data: result } = await api.get("/users");

          setUsers(result.users);
          setSelectedUser(user.id);

          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    } else if (open === "create") {
      (async () => {
        try {
          const { data: result } = await api.get("/users");
          setUsers(result.users);

          setSelectedUser("");
          setActiveModal(true);
        } catch (error) {
          console.log(error);
        }
      })();
    }
    return () => {
      isMounted.current = false;
    };
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveContact = () => {
    if (!selectedUser) {
      return toast.error("Adicione um atendente");
    }
    if (open === "edit") {
      const user = users.find((item) => item.id === selectedUser);

      onUpdate({
        ...data,
        data: {
          user: user ? user : "",
        },
      });
    } else if (open === "create") {
      const user = users.find((item) => item.id === selectedUser);

      onSave({
        user: user ? user : "",
      });
    }
    handleClose();
  };

  return (
    <Dialog
      open={activeModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="paper"
    >
      <ModalTitle
        id="form-dialog-title"
        title={open === "create" ? `Adicionar um atendente ao fluxo` : `Editar atendente`}
        subtitle="Entrega a conversa a um atendente quando o fluxo chega neste ponto."
        onClose={handleClose}
      />
      <DialogContent>
        <FormField label="Escolha um atendente">
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              id="flow-attendant-select"
              value={selectedUser}
              displayEmpty
              onChange={(e) => {
                setSelectedUser(e.target.value);
              }}
              MenuProps={MENU_PROPS}
              renderValue={() => {
                if (selectedUser === "") {
                  return "Selecione um usuário";
                }
                const user = users.find((usr) => usr.id === selectedUser);
                if (user === undefined) {
                  return "Selecione um usuário";
                }
                return user.name;
              }}
            >
              <MenuItem value="">
                <em>Selecione um usuário</em>
              </MenuItem>
              {users.length > 0 &&
                users.map((user, index) => (
                  <MenuItem dense key={index} value={user.id}>
                    {user.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </FormField>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          {i18n.t("contactModal.buttons.cancel")}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={handleSaveContact}
        >
          {open === "create" ? `Adicionar` : "Editar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAttendantModal;
